const transitionEnd = require('./transition-end').default;
const { isTag, forEachElement } = require('../common/utils/dom');

const togglerButtonSelector = '[data-interaction="expand"]';
const interactionActiveClass = 'interaction-active';
const triggerEvent = 'click';

function init() {
  $('body').on(`${triggerEvent}`, togglerButtonSelector, (e) => {
    if (isTag(e.target, 'a')) {
      e.preventDefault();
    }
    e.stopPropagation();
    const togglerButton = e.target.closest(togglerButtonSelector);
    const relation = togglerButton.getAttribute('data-interaction-relation');
    let dependant;
    if (relation === 'sibling') {
      // eslint-disable-next-line prefer-destructuring
      dependant = $(togglerButton).siblings('[data-interaction-dependant]')[0];
    } else if (relation === 'child') {
      dependant = togglerButton.querySelector('[data-interaction-dependant]');
    } else if (relation === 'any') {
      const targetValue = togglerButton.getAttribute('data-interaction-target');
      dependant = document.querySelector(
        `[data-interaction-dependant][data-interaction-target=${targetValue}]`
      );
    }

    if (dependant) {
      toggle(dependant, e.target);
    }
  });
}

function removeActiveFromSiblingGroups(newActiveGroup) {
  const parentWrapper = newActiveGroup.closest('.expand-elements-wrapper');
  if (parentWrapper.dataset.allowMultipleOpened === 'true') {
    return;
  }
  const siblingElements = parentWrapper.querySelectorAll(
    `.${interactionActiveClass}`
  );

  forEachElement(siblingElements, (i) => {
    i.classList.remove(interactionActiveClass);
  });
}

function calculateHeight(targetElement, extraElement = null) {
  const height = extraElement
    ? getElementHeight(targetElement, extraElement)
    : getElementHeight(targetElement);
  targetElement.setAttribute('style', `--max-h:${height}`);
}

function toggle(dependantElement, togglerElement = null, callback = null) {
  if (!dependantElement.classList.contains('interaction--expand')) {
    return;
  }

  // transitionEnd can be called if/when we call toggle with a 3rd argument
  if (callback && togglerElement !== null) {
    transitionEnd.once(togglerElement, callback);
  }

  dependantElement.classList.remove('interaction--initially-expanded');

  // we will calculate the height on the firstChild, since
  // current item will have no height if max-height is 0 (default)
  const isNotInteractionActiveClass = !dependantElement.classList.contains(
    interactionActiveClass
  );
  if (isNotInteractionActiveClass && togglerElement !== null) {
    removeActiveFromSiblingGroups(togglerElement);
  }

  const isHeightSetting = dependantElement.getAttribute('style')
    ? dependantElement.getAttribute('style').includes('--max-h')
    : false;

  if (isNotInteractionActiveClass || !isHeightSetting) {
    // calculate the height to expand if max height is not setting before
    if (dependantElement.dataset.expandUpdateTarget) {
      calculateHeight(
        $(dependantElement.dataset.expandUpdateTarget)[0],
        dependantElement
      );
    } else {
      calculateHeight(dependantElement);
    }
  }

  dependantElement.classList.toggle(interactionActiveClass);
}

function destroy() {
  $('body').off(triggerEvent);
}

function getElementHeight(contentElem, extraElement = null) {
  let height = 0;
  if (contentElem.children.length > 0) {
    height = 0;
    forEachElement(contentElem.children, (child) => {
      height += $(child).outerHeight(true);
    });
  } else {
    height = contentElem.scrollHeight;
  }

  if (extraElement) {
    height += extraElement.scrollHeight;
  }
  return `${height}px`;
}

module.exports = {
  calculateHeight,
  destroy,
  getElementHeight,
  init,
  isExpanded: (dependantElement) =>
    dependantElement.classList.contains(interactionActiveClass),
  toggle,
};
